/**
 * Build configuration constants
 */

export const BUILD = {
  /**
   * Directory where the static site is built
   * This must be 'docs' for GitHub Pages compatibility
   */
  outputDir: 'docs',
} as const;
